import Dialog from "@mui/material/Dialog";
import Paper from "@mui/material/Paper";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { mobilePageMaxWidth } from "./HXMobilePage.styles";
export const BottomSheetPaper = styled(Paper) `
    background-color: ${colors.white_main};

    && {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        max-width: ${mobilePageMaxWidth}px;
        margin: 0;
        max-height: 95%;
        width: 100%;
        align-self: flex-end;
        border-radius: 32px 32px 0 0;
        border: none;
        box-shadow: 0px -203px 57px 0px rgba(0, 0, 0, 0), 0px -130px 52px 0px rgba(0, 0, 0, 0.01), 0px -73px 44px 0px rgba(0, 0, 0, 0.04),
            0px -32px 32px 0px rgba(0, 0, 0, 0.07), 0px -8px 18px 0px rgba(0, 0, 0, 0.08);
    }
`;
export const BottomSheetDialogEl = styled(Dialog) `
    .MuiBackdrop-root {
        background-color: rgba(0, 0, 0, 0.2);
    }

    .MuiDialog-container {
        align-items: flex-end;
    }

    .MuiDialog-paper {
        overflow: hidden;
    }
`;
export const BottomSheetHeader = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    flex-shrink: 0;
    width: 100%;
    padding: 24px 24px 0;
    box-sizing: border-box;
`;
export const BottomSheetCloseButton = styled.button `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    background-color: transparent;
    border: 1px solid ${colors.black_lighter};
    border-radius: 100px;
    color: ${colors.black_lighter};
    cursor: pointer;
    flex-shrink: 0;
    font: inherit;
    line-height: 0;

    @media (hover: hover) {
        &:hover {
            background-color: ${colors.black_4};
        }
    }
`;
export const BottomSheetTitleBlock = styled.div `
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: ${(props) => { var _a; return (_a = props.$gap) !== null && _a !== void 0 ? _a : "3px"; }};
`;
export const BottomSheetTitle = styled.h2 `
    margin: 0;
    font-size: ${fontSizes.LARGE};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_main};
    line-height: 1;
`;
export const BottomSheetSubtitle = styled.p `
    margin: 0;
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_lighter};
    letter-spacing: 0.24px;
    text-transform: uppercase;
`;
export const BottomSheetContent = styled.div `
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding-bottom: env(safe-area-inset-bottom, 24px);
`;
export const BottomSheetInner = styled.div `
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px 24px 100px;
`;
